module.exports = __webpack_public_path__ + "static/img/relatorio-mapa.f50d1d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/relatorio-mapa.png
// module id = IAcT
// module chunks = 1